/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import type { ScopeIdentifier } from '@atlassian/jira-common-navigation/src/get-scope-identifier/types.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { ProjectSidebarNavInfo } from './types.tsx';

export const fetchProjectSidebarNavInfo = (
	scopeIdentifier: ScopeIdentifier,
): Promise<ProjectSidebarNavInfo> => {
	const { identifierType, identifierValue } = scopeIdentifier;
	if (identifierType == null || identifierValue == null) {
		throw new Error('invalid identifier specified');
	}

	if (expVal('frontier-guided-autonomy-eap', 'isEnabled', false)) {
		const params = new URLSearchParams();
		switch (identifierType) {
			case 'boardId':
				params.set('boardId', identifierValue);
				break;
			case 'projectKey':
			case 'projectId':
				params.set('projectIdOrKey', identifierValue);
				break;
			default:
				break;
		}
		params.set('includePolicyStatus', 'true');
		return performGetRequest(`/rest/navigation/4/sidebar?${params.toString()}`);
	}

	let queryParam = '';
	switch (identifierType) {
		case 'boardId':
			queryParam = `boardId=${identifierValue}`;
			break;
		case 'projectKey':
		case 'projectId':
			queryParam = `projectIdOrKey=${identifierValue}`;
			break;
		default:
			break;
	}
	return performGetRequest(`/rest/navigation/4/sidebar?${queryParam}`);
};
